import { CriteriaProps } from '~/screens/types';

// Performance metrics of Instagram Followers
export const followers: CriteriaProps[] = [
  { label: '0', value: 0, display: true },
  { label: '≥ 5K', value: 5000 },
  { label: '≥ 10K', value: 10000, display: true },
  { label: '≥ 50K', value: 50000 },
  { label: '≥ 100K', value: 100000, display: true },
  { label: '≥ 175K', value: 175000 },
  { label: '≥ 250K', value: 250000, display: true },
  { label: '≥ 375K', value: 375000 },
  { label: '≥ 500K', value: 500000, display: true },
  { label: '≥ 1M+', value: 1000000, display: true },
];

// Performance metrics of Instagram Reach Engagement Rate
export const reachEngagementRate: CriteriaProps[] = [
  { label: '0%', value: 0, display: true },
  { label: '≥ 1%', value: 0.01 },
  { label: '≥ 2%', value: 0.02, display: true },
  { label: '≥ 3%', value: 0.03 },
  { label: '≥ 4%', value: 0.04, display: true },
  { label: '≥ 5%', value: 0.05 },
  { label: '≥ 6%', value: 0.06, display: true },
  { label: '≥ 7%', value: 0.07 },
  { label: '≥ 8%', value: 0.08, display: true },
  { label: '≥ 9%', value: 0.09 },
  { label: '≥ 10%', value: 0.1, display: true },
];

// Performance metrics of Instagram Average Feed Reach
export const averageFeedReach: CriteriaProps[] = [
  { label: '0', value: 0, display: true },
  { label: '≥ 5K', value: 5000 },
  { label: '≥ 10K', value: 10000, display: true },
  { label: '≥ 50K', value: 50000 },
  { label: '≥ 100K', value: 100000, display: true },
  { label: '≥ 175K', value: 175000 },
  { label: '≥ 250K', value: 250000, display: true },
  { label: '≥ 375K', value: 375000 },
  { label: '≥ 500K', value: 500000, display: true },
  { label: '≥ 1M+', value: 1000000, display: true },
];

// Performance metrics of Instagram Average Story Reach
export const averageStoryReach: CriteriaProps[] = [
  { label: '0', value: 0, display: true },
  { label: '≥ 5K', value: 5000 },
  { label: '≥ 10K', value: 10000, display: true },
  { label: '≥ 50K', value: 50000 },
  { label: '≥ 100K', value: 100000, display: true },
  { label: '≥ 175K', value: 175000 },
  { label: '≥ 250K', value: 250000, display: true },
  { label: '≥ 375K', value: 375000 },
  { label: '≥ 500K', value: 500000, display: true },
  { label: '≥ 1M+', value: 1000000, display: true },
];

// Performance metrics of Instagram Average Reels Views
export const averageReelsViews: CriteriaProps[] = [
  { label: '0', value: 0, display: true },
  { label: '≥ 50K', value: 50000 },
  { label: '≥ 100K', value: 100000, display: true },
  { label: '≥ 175K', value: 175000 },
  { label: '≥ 250K', value: 250000, display: true },
  { label: '≥ 375K', value: 375000 },
  { label: '≥ 500K', value: 500000, display: true },
  { label: '≥ 750K', value: 750000 },
  { label: '≥ 1M+', value: 1000000, display: true },
  { label: '≥ 2M+', value: 2000000 },
  { label: '≥ 3M+', value: 3000000, display: true },
];

// Performance metrics of Youtube Subscribers
export const subscribers: CriteriaProps[] = [
  { label: '0', value: 0, display: true },
  { label: '≥ 5K', value: 5000 },
  { label: '≥ 10K', value: 10000, display: true },
  { label: '≥ 125K', value: 125000 },
  { label: '≥ 250K', value: 250000, display: true },
  { label: '≥ 375K', value: 375000 },
  { label: '≥ 500K', value: 500000, display: true },
  { label: '≥ 750K', value: 750000 },
  { label: '≥ 1M+', value: 1000000, display: true },
  { label: '≥ 2.5M+', value: 2500000 },
  { label: '≥ 5M+', value: 5000000, display: true },
];

// Performance metrics of Youtube Average Views
export const averageViews: CriteriaProps[] = [
  { label: '0', value: 0, display: true },
  { label: '≥ 5K', value: 5000 },
  { label: '≥ 10K', value: 10000, display: true },
  { label: '≥ 125K', value: 125000 },
  { label: '≥ 250K', value: 250000, display: true },
  { label: '≥ 375K', value: 375000 },
  { label: '≥ 500K', value: 500000, display: true },
  { label: '≥ 750K', value: 750000 },
  { label: '≥ 1M+', value: 1000000, display: true },
  { label: '≥ 2.5M+', value: 2500000 },
  { label: '≥ 5M+', value: 5000000, display: true },
];

// Performance metrics of Youtube Average Engagement Rate
export const averageEngagementRate: CriteriaProps[] = [
  { label: '0%', value: 0, display: true },
  { label: '≥ 1%', value: 0.01 },
  { label: '≥ 2%', value: 0.02, display: true },
  { label: '≥ 3%', value: 0.03 },
  { label: '≥ 4%', value: 0.04, display: true },
  { label: '≥ 5%', value: 0.05 },
  { label: '≥ 6%', value: 0.06, display: true },
  { label: '≥ 7%', value: 0.07 },
  { label: '≥ 8%', value: 0.08, display: true },
  { label: '≥ 9%', value: 0.09 },
  { label: '≥ 10%+', value: 0.1, display: true },
];

// Performance metrics of Tiktok followers
export const tiktokFollowers: CriteriaProps[] = [
  { label: '0', value: 0, display: true },
  { label: '≥ 5K', value: 5000 },
  { label: '≥ 10K', value: 10000, display: true },
  { label: '≥ 125K', value: 125000 },
  { label: '≥ 250K', value: 250000, display: true },
  { label: '≥ 375K', value: 375000 },
  { label: '≥ 500K', value: 500000, display: true },
  { label: '≥ 750K', value: 750000 },
  { label: '≥ 1M+', value: 1000000, display: true },
  { label: '≥ 2.5M+', value: 2500000 },
  { label: '≥ 5M+', value: 5000000, display: true },
];

// Performance metrics of Tiktok Average Views
export const tiktokAverageViews: CriteriaProps[] = [
  { label: '0', value: 0, display: true },
  { label: '≥ 25K', value: 25000 },
  { label: '≥ 50K', value: 50000, display: true },
  { label: '≥ 125K', value: 125000 },
  { label: '≥ 250K', value: 250000, display: true },
  { label: '≥ 375K', value: 375000 },
  { label: '≥ 500K', value: 500000, display: true },
  { label: '≥ 750K', value: 750000 },
  { label: '≥ 1M', value: 1000000, display: true },
  { label: '≥ 5M', value: 5000000 },
  { label: '≥ 10M+', value: 10000000, display: true },
];
// Performance metrics of Tiktok Average Engagement Rate
export const tiktokAverageEngagementRate: CriteriaProps[] = [
  { label: '0%', value: 0, display: true },
  { label: '≥ 2,5%', value: 0.025 },
  { label: '≥ 5%', value: 0.05, display: true },
  { label: '≥ 7,5%', value: 0.075 },
  { label: '≥ 10%', value: 0.1, display: true },
  { label: '≥ 12,5%', value: 0.125 },
  { label: '≥ 15%', value: 0.15, display: true },
  { label: '≥ 17,5%', value: 0.175 },
  { label: '≥ 20%', value: 0.2, display: true },
  { label: '≥ 22,5%', value: 0.225 },
  { label: '≥ 25%', value: 0.25, display: true },
];

// Performance metrics of Snapchat Followers
export const snapchatFollowers: CriteriaProps[] = [
  { label: '0', value: 0, display: true },
  { label: '≥ 5K', value: 5000 },
  { label: '≥ 10K', value: 10000, display: true },
  { label: '≥ 50K', value: 50000 },
  { label: '≥ 100K', value: 100000, display: true },
  { label: '≥ 175K', value: 175000 },
  { label: '≥ 250K', value: 250000, display: true },
  { label: '≥ 375K', value: 375000 },
  { label: '≥ 500K', value: 500000, display: true },
  { label: '≥ 1M+', value: 1000000, display: true },
];
